import { useContext, useState } from "react";
import axios from 'fetch/axios';
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useAuth } from "@context/AuthContext";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const RestablecerPassword = () => {
  const MySwal = withReactContent(Swal)
  const [emailValue, setEmail] = useState("");
  const { translate } = useTranslation();
  const { lang } = useContext(LanguageCurrencyContext);
  const { setAuthPage } = useAuth();
  const [loading, setLoading] = useState(true)

  const EnviarReset = async e => {

    if (emailValue) {
      try {
        setLoading(false);
        const res = await axios.post(
          "/users/password-recovery",
          {
            email: emailValue,
            lang: lang
          }
        );
        setLoading(true)
        if (res.data.errors) {
          MySwal.fire({
            text: res.data.message,
            icon: 'error',
            title: 'Oops...'
          })

        } else {
          localStorage.setItem('token_recuperar_clave', res.data.token);
          localStorage.setItem('token_email', emailValue);
          setAuthPage('ConfirmarCorreoRecuperar');
        }
      } catch (error) {
        setLoading(true)
        if (error.response.status === 400) {
          MySwal.fire({
            text: error.response.data,
            icon: 'error',
            title: 'Oops...'
          })

        } else {

          MySwal.fire({
            text: translate('login.error5'),
            icon: 'error',
            title: 'Oops...'
          })

        }
      }
    } else {
      MySwal.fire({
        text: translate('login.error4'),
        icon: 'error',
        title: 'Oops...'
      })

    }
  };

  return (
    <>
      {!loading && <Spinner />}

      <div>
        {translate('recovery.enter')} .
      </div>
      <label className="FormData">
        <em className="RequiredData">{translate('login.email')}</em>
        <div className="FormInput">
          <input placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
        </div>
      </label>
      <div
        className="ButtonLightMedium"
        onClick={EnviarReset}
      >
        {translate('recovery.titleM')}
        <i className="icon-ArrowRight"></i>
      </div>
    </>
  );
};

export default RestablecerPassword;
